<template>
  <div>
    <template v-if="!detail">
      <template v-if="itemsCount === 0"> — </template>

      <template v-else-if="itemsCount === 1">
        <div v-if="single">
          <slot
            name="single"
            :item="single"
          />
        </div>
        <div v-else>—</div>
      </template>

      <template v-else>
        <div class="d-flex align-items-center gap-5">
          <span class="badge badge-primary-lighter">{{ itemsCount }}</span>
          <strong>{{ label }}</strong>
        </div>
      </template>
    </template>

    <template v-else>
      <div class="details-container-wrapper">
        <slot
          name="detail"
          :items="items"
        />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MergeCandidatesExpandableCell',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      required: true,
    },
    detail: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    itemsCount() {
      return this.items?.length || 0;
    },
    single() {
      return this.items?.[0];
    },
  },
};
</script>
